import * as types from '../../../constants/actionTypes';

export function fetchStatistics(profileId) {
    return {
        types: [
            types.FETCH_STATISTICS,
            types.FETCH_STATISTICS_SUCCESS,
            types.FETCH_STATISTICS_FAIL,
        ],
        promise: (client) =>
            client.get(`/api/profiles/${profileId}/statistics`),
    };
}
